import { Component, OnInit } from '@angular/core';
import { APP_DEFAULTS, APP_TEXT_EN, APP_TEXT_ES, THEMEDATA } from '../../../shared/constants/app.constants';
import { GlobalService } from '../../../shared/services/global.service';
import { UtilService } from 'src/app/shared/services/utils.service';
import { SharedDataService } from 'src/app/shared/services/registration.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {

  ctaDisabled:boolean = false;
  public language : string = 'EN';
  public textConstants: any = this.language === 'EN' ? APP_TEXT_EN : APP_TEXT_ES;

  public phone!: string;
  public jobCode: string = '';
  public logoURL: string = '';
  public phoneURL!: string;//'tel:' + this.phone;
  public eventCount: number = 0;
  public ctaButtonText!: string
  langDictionary:any;



  constructor(private scrollService: UtilService, private globalService: GlobalService, private sharedDataService: SharedDataService) { }

  

  ngOnInit(): void {
    this.sharedDataService.ctaDisableData.subscribe(data=>{
      this.ctaDisabled = data;
    })
    this.langDictionary = this.globalService.Language;    
    this.globalService.jobInformation.subscribe((data) => {
      this.jobCode = data?.jobCode;
      data.pageData && data.pageData.sectionHeader && data.pageData.sectionHeader.logoImageURL && data.pageData.sectionHeader.logoImageURL != '' ? this.logoURL = data.pageData.sectionHeader.logoImageURL : this.logoURL = '';
      this.eventCount = data.eventCount || 0;
      if (this.eventCount < 2) {
        this.ctaButtonText = data?.pageData?.sectionHeader?.ctaButtonSelectEvent || this.langDictionary.HEADER.CTA_BUTTON_TEXT_SINGLE;
      }else{
        this.ctaButtonText = data?.pageData?.sectionHeader?.ctaButtonSelectEvent || this.langDictionary.HEADER.CTA_BUTTON_TEXT;
      }
      this.phone = data?.pageData?.sectionHeader?.phoneNumber || APP_DEFAULTS.PHONE;
      this.phoneURL = "tel:" + this.phone
    });
  }



  clickCTA() {    
    if(this.globalService.eventCount == 1){
      this.scrollService.triggerScroll('scrollToRegister');
    } else if(this.globalService.eventCount > 1){
      this.scrollService.triggerScroll('scrollToEvents');
    }
  }

}
